
// --- Vue & Template imports ---
import { Component, Vue} from 'vue-property-decorator';

// --- Models ---
import { Adjustment, AdjustmentHeader } from '@/models/Route.model';

// --- Services ---
import AppService from '@/services/app';
import ReportService from '@/services/report';
import RouteAjustmentService from '@/services/routeAdjustment';

// --- Third Party ---

@Component
export default class RouteAdjustmentListing extends Vue {
  // used by Filter Area
  search: string = '';
  filterOptions: string[] = ['Waiting Approval', 'Waiting Implementation'];
  filter: string = 'Waiting Approval';

  // used by No Data Slot
  isLoading: boolean = true;

  displayAdjustments: AdjustmentHeader[] = [];

  clickedItem: AdjustmentHeader = {
    id: 0,
    customerId: 0,
    customerName: '',
    customerCode: '',
    effectiveDate: '',
    amount: '',
    adjustUp: false,
    description: '',
    count: 0,
    applied: false,
  };

  showViewDialog: boolean = false;
  isViewLoading: boolean = true;
  displayRoutes: Adjustment[] = [];

  // used by Dialog for Email Rates Sheet
  showEmailRatesSheetDialog: boolean = false;
  emailRatesSheetDialogTitle: string = '';
  emailValid: boolean = false;
  toEmailAddress: string = '';
  emailRatesClicked: boolean = false;

  // used by Confirm Action Dialog for Delete
  action: string = '';
  dialogContent: string = '';
  showConfirmActionDialog: boolean = false;
  confirmActionDelay: boolean = false;

  rules = {
    required: (value: string) => !!value || '',
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid',
  };

  // #region Functions to display list data on page load
    headers() {
      if (this.filter === 'Waiting Approval') {
        return [
          {
            text: 'Date',
            value: 'effectiveDate',
          },
          {
            text: 'Client',
            value: 'customerCode',
          },
          {
            text: 'Description',
            value: 'description',
          },
          {
            text: 'Amount',
            value: 'amount',
            align: 'end',
          },
          {
            text: 'Type',
            value: 'adjustUp',
          },
          {
            text: 'Count',
            value: 'count',
          },
          {
            sortable: false,
            text: '',
            value: 'action',
            align: 'end',
          },
        ];
      } else {
        return [
          {
            text: 'Date',
            value: 'effectiveDate',
          },
          {
            text: 'Client',
            value: 'customerCode',
          },
          {
            text: 'Description',
            value: 'description',
          },
          {
            text: 'Amount',
            value: 'amount',
            align: 'end',
          },
          {
            text: 'Type',
            value: 'adjustUp',
          },
          {
            text: 'Count',
            value: 'count',
          },
          {
            text: 'Approved',
            value: 'approved',
          },
          {
            sortable: false,
            text: '',
            value: 'action',
            align: 'end',
          },
        ];
      }
    }

    routeHeaders() {
      return [
        {
          text: 'From',
          value: 'from',
        },
        {
          text: 'To',
          value: 'to',
        },
        {
          text: 'KM',
          value: 'routeKm',
        },
        {
          text: 'Old Rate',
          value: 'oldRate',
          align: 'right',
        },
        {
          text: 'Difference',
          value: 'difference',
          align: 'right',
        },
        {
          text: 'New Rate',
          value: 'newRate',
          align: 'right',
        },
        {
          text: 'Type',
          value: 'rateType',
          align: 'right',
        },
      ];
    }

    async beforeMount() {
      await this.listAll();

      this.filterAdjustments();
;    }

    async listAll() {
      try {
        this.isLoading = true;
        const response: string = await RouteAjustmentService.listAll(true);

        if (response.length > 0 && response !== 'No Data Found') {
          AppService.errorHandler(response);
        }

      } finally {
        this.isLoading = false;
      }
    }

    async filterAdjustments() {
      switch (this.filter) {
        case ('Waiting Approval'):
          this.displayAdjustments = this.$store.getters['routes/adjustmentHeaders'].filter((item: AdjustmentHeader) => !item.approvedAt);
          break;

        case ('Waiting Implementation'):
          this.displayAdjustments = this.$store.getters['routes/adjustmentHeaders'].filter((item: AdjustmentHeader) => item.approvedAt);
          break;
      }
    }

    allowEmailRatesFunctionality() {
      return this.$store.getters['app/allowAccess'](this.$store.getters['users/loggedInUser'], [
        { type: 'Super User', level: 1},
        { type: 'Operator', level: 3},
      ]);
    }

    allowApproveFunctionality() {
      return this.$store.getters['app/allowAccess'](this.$store.getters['users/loggedInUser'], [
        { type: 'Super User', level: 2},
      ]);
    }

    allowDeleteFunctionality() {
      return this.$store.getters['app/allowAccess'](this.$store.getters['users/loggedInUser'], [
        { type: 'Super User', level: 2},
      ]);
    }
  // #endregion

  // #region Functions required for the View Dialog
    async viewRoutesToAdjust(item: AdjustmentHeader) {
      this.clickedItem = item;
      this.showViewDialog = true;

      // go fetch the relevant rates
      try {
        this.isViewLoading = true;

        const response = await RouteAjustmentService.listAdjustmentsByHeader({ params: {
          headerId: this.clickedItem.id,
        }});

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            this.displayRoutes = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('RateAdjustments.vue - viewRoutesToAdjust - 735 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.isViewLoading = false;
      }
    }
  // #endregion

  // #region Functions required for the Dialog to Email Rates Sheet
    async launchEmailRatesSheetDialog(item: AdjustmentHeader) {
      this.clickedItem = item;

      this.emailValid = false;
      this.toEmailAddress = '';
      this.emailRatesSheetDialogTitle = 'Email ' + this.clickedItem.customerCode + ' Updated Rates';

      if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).resetValidation();
      }

      this.showEmailRatesSheetDialog = true;
    }

    async emailRatesSheet() {
      try {
        this.emailRatesClicked = true;

        const response = await ReportService.emailAdjustmentRatesSheet({
          customerId: this.clickedItem.customerId,
          routeAdjustmentHeaderId: this.clickedItem.id,
          emailAddress: this.toEmailAddress,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            this.showEmailRatesSheetDialog = false;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('RateAdjustments.vue - emailRatesSheet - 786 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.emailRatesClicked = false;
      }
    }
  // #endregion

  // #region Functions required for the Confirm Action Dialog for Delete/Approve
    async launchDeleteItemDialog(item: AdjustmentHeader) {
      this.clickedItem = item;

      this.action = 'DELETE';
      this.dialogContent = 'You are about to <span style="font-weight: 700;color: #C01212">delete</span> ' 
        + ' the ' + this.$store.getters['app/displayAsCurrency'](this.clickedItem.amount) + ' rate ' + (this.clickedItem.adjustUp ? 'increase' : 'decrease') + ' for ' + this.clickedItem.customerCode;
      this.showConfirmActionDialog = true;
    }

    async launchApproveItemDialog(item: AdjustmentHeader) {
      this.clickedItem = item;

      this.action = 'APPROVE';
      this.dialogContent = 'You are about to <span style="font-weight: 700;color: #71BC78">approve</span> ' 
        + ' the ' + this.$store.getters['app/displayAsCurrency'](this.clickedItem.amount) + ' rate ' + (this.clickedItem.adjustUp ? 'increase' : 'decrease') + ' for ' + this.clickedItem.customerCode;
      this.showConfirmActionDialog = true;
    }

    ConfirmActionDialog_cancel() {
      this.showConfirmActionDialog = false;
    }

    async ConfirmActionDialog_doConfirmed() {
      if (this.action === 'APPROVE') {
        await this.doApprove();
      } else if (this.action === 'DELETE') {
        await this.doDelete();
      }
    }

    async doApprove() {
      try {
        this.confirmActionDelay = true;

        const response = await RouteAjustmentService.approve({
          id: this.clickedItem.id,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            await this.listAll();
            this.filterAdjustments();
            this.showConfirmActionDialog = false;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('RateAdjustments.vue - doApprove - 853 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.confirmActionDelay = false;
      }
    }

    async doDelete() {
      try {
        this.confirmActionDelay = true;

        const response = await RouteAjustmentService.delete({
          id: this.clickedItem.id,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            await this.listAll();
            this.filterAdjustments();
            this.showConfirmActionDialog = false;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('RateAdjustments.vue - doDelete - 888 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.confirmActionDelay = false;
      }
    }
  // #endregion
}
